import { render } from "./Error.vue?vue&type=template&id=1935d68f"
const script = {}

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__